import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreNotificationsIssueLogsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-notifications-issue-logs',
	path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
	exact: true,
};
